import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Injectable({
  providedIn: 'root',
})
export class TaskService {
  private taskList = new BehaviorSubject<any[]>([]);
  tasks$ = this.taskList.asObservable(); // Expose tasks as observable

  constructor(
    private localStorage: LocalStorageService
  ) {}

  setTasks(newTasks: any[]) {
    this.taskList.next(newTasks);
  }

  addTask(newTask: any) {
  
    let newTaskObj:any = {
        name: this.localStorage.getProfileName(),
        date: moment(newTask.updatedAt).format('DD/MM/YYYY HH:mm'),
        desc: newTask.tasks_name,
        id: newTask.id
    }

    this.taskList.next([newTaskObj, ...this.taskList.value]);
  }

}
